import React, {useContext} from "react";
import {useHistory} from "react-router";
import URLSearchParamsConverter from "../../utils/URLSearchParamsConverter";
import BrandImages from "../../utils/BrandImages";
import {SearchOptionsContext} from "../../context/search-options-context";

const OffersSubmenu = (props) => {
    const history = useHistory();
    const searchOptions = useContext(SearchOptionsContext);

    const bodyTypes = [
        { name: "Kombi", label: "Kombi" },
        { name: "Hatchback", label: "Hatchback" },
        { name: "SUV", label: "SUV" },
        { name: "Sedan", label: "Sedan" },
        { name: "Pick-up", label: "Pick-up" }
    ];

    const installments = [
        { label: "do 1500 zł / m-c", net: 1500, gross: 1845 },
        { label: "do 2000 zł / m-c", net: 2000, gross: 2460 },
        { label: "do 2500 zł / m-c", net: 2500, gross: 3075 },
        { label: "do 3000 zł / m-c", net: 3000, gross: 3690 },
        { label: "do 3500 zł / m-c", net: 3500, gross: 4305 },
        { label: "do 4000 zł / m-c", net: 4000, gross: 4920 },
        { label: "do 4500 zł / m-c", net: 4500, gross: 5535 },
        { label: "do 5000 zł / m-c", net: 5000, gross: 6150 }
    ];

    const fuelTypes = [
        { name: "Elektryczny", label: "Elektryczny" },
        { name: "Hybrydowy", label: "Hybrydowy" },
        { name: "Benzyna", label: "Benzyna" },
        { name: "Benzyna/LPG", label: "Benzyna/LPG" },
        { name: "Diesel", label: "Diesel" }
    ];

    const popularBrands = [
        "bmw", "mercedes-benz", "audi", "citroen", "fiat", "ford", "hyundai", "mazda", "kia"
    ];

    const handleSearch = (params) => {
        history.push({
            pathname: "/lista-ofert",
            search: URLSearchParamsConverter.createURLSearchString(params)
        });
        props.onClose();
    };

    const renderColumn = (title, items, type) => (
        <div className="sub-menu-column">
            <h4>{title}</h4>
            <ul>
                {items.map((item, index) => {
                    let onClick = () => {};
                    let content = null;

                    if (type === 'body') {
                        onClick = () => handleSearch({ bodyTypes: [item.name] });
                        content = item.label;
                    } else if (type === 'installment') {
                        onClick = () => handleSearch({
                            installmentNetTo: item.net,
                            installmentGrossTo: item.gross
                        });
                        content = item.label;
                    } else if (type === 'fuel') {
                        onClick = () => handleSearch({ fuelTypes: [item.name] });
                        content = item.label;
                    } else if (type === 'brand') {
                        const brandData = BrandImages[item.toLowerCase()];
                        // Re-evaluating brand search param:
                        onClick = () => handleSearch({ brands: [item] });
                        content = (
                            <>
                                {brandData && <img src={brandData.smallIcon} alt={item} />}
                                <span>{item}</span>
                            </>
                        );
                    }

                    return (
                        <li key={index} onClick={onClick}>
                            {content}
                        </li>
                    );
                })}
            </ul>
        </div>
    );

    return (
        <div className="offers-submenu">
            {renderColumn("WYBIERZ WG NADWOZIA", bodyTypes, 'body')}
            {renderColumn("WYBIERZ WG RATY", installments, 'installment')}
            {renderColumn("WYBIERZ WG PALIWA", fuelTypes, 'fuel')}
            {renderColumn("NAJPOPULARNIEJSZE MARKI", searchOptions.popularBrands, 'brand')}
            <div className="clearfix"></div>
        </div>
    );
};

export default OffersSubmenu;
